import angular from 'angular';
import factFindSidebar from './factFindSidebar';

export default angular
  .module('components.factFindSidebar', [])
  .component('factFindSidebar', factFindSidebar).name;
